import { render, staticRenderFns } from "./AddServiceQuotation.vue?vue&type=template&id=6315854d&scoped=true&"
import script from "./AddServiceQuotation.vue?vue&type=script&lang=js&"
export * from "./AddServiceQuotation.vue?vue&type=script&lang=js&"
import style0 from "./AddServiceQuotation.vue?vue&type=style&index=0&id=6315854d&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6315854d",
  null
  
)

export default component.exports